import React from 'react';
import { Icon } from 'antd';

const optionsDefault = {
  okText: 'Готово',
  icon: <Icon type="check-circle" theme="filled" />,
  closable: false,
  maskClosable: true,
  centered: true,
  className: 'employee-success-form',
  onOk() {},
  onCancel() {},
};

export const successCreateExecutor = name => ({
  ...optionsDefault,
  title: 'Исполнитель успешно сохранен!',
  content: `Исполнитель «${name}» успешно сохранен!`,
});

export const successUpdateExecutor = name => ({
  ...optionsDefault,
  title: 'Изменения успешно сохранены!',
  content: `Изменения успешно внесены в профиль исполнителя «${name}».`,
});

export const successDeleteExecutor = name => ({
  ...optionsDefault,
  title: 'Исполнитель успешно арихивирован!',
  content: `Исполнитель «${name}» успешно архивирован. Вы не сможете оформлять заказы от лица данного исполнителя.`,
});

export const successRestoreArchiveExecutor = name => ({
  ...optionsDefault,
  title: 'Исполнитель успешно восстановлен!',
  content: `Исполнитель «${name}» успешно восстановлен.`,
});

export const successDeleteSelectedTemplates = count => ({
  ...optionsDefault,
  title: 'Выбранные шаблоны успешно удалены!',
  content: `Шаблоны успешно удалены!`,
});

// Вы уверены, что хотите архивировать исполнителя? Он будет не активен для аккаунта.

// Внимание!
// Вы действительно хотите восстановить исполнителя?

// Исполнитель успешно арихивирован!
// Исполнитель «Константинопольский Константин Константинович» успешно архивирован. Вы не сможете оформлять заказы от лица данного исполнителя.

// Исполнитель успешно восстановлен!
// Исполнитель «Константинопольский Константин Константинович» успешно восстановлен.
